module.exports = __webpack_public_path__ + "static/media/folder.dbef482d.png";